import { listBoxOption } from 'components/Form/SelectField/SelectField.helpers';
import { ListboxOption } from 'components/Form/SelectField/SelectField.types';
import { documentDateValidator } from 'utils/validation/date';
import { basePasswordFieldValidation } from 'utils/validation/password';
import { requiredField } from 'utils/validation/required';
import { z } from 'zod';

export const documentTypeField = 'documentType';
export const documentNumberField = 'documentNumber';
export const expiryDateField = 'expirationDate';
export const usernameField = 'username';
export const passwordField = 'password';
export const flagPrivacyField = 'flagPrivacy';

//we use these for custom validation so we export them in case they change value in future
export const identityCardOptionValue = 1;
export const recidencyPermitOptionValue = 3;

export const documentOptions: ListboxOption[] = [
  {
    label: 'personalDataStep.select.documentType.ci',
    optionId: identityCardOptionValue,
  },
  {
    label: 'personalDataStep.select.documentType.ps',
    optionId: recidencyPermitOptionValue,
  },
];

export const securityDataFormDefaultValues = {
  [documentTypeField]: documentOptions[0],
  [documentNumberField]: '',
  [expiryDateField]: '',
  [usernameField]: '',
  [passwordField]: '',
  [flagPrivacyField]: false,
};

export const securityDataStepFormValidationBaseSchema = z.object({
  [documentTypeField]: listBoxOption,
  [documentNumberField]: requiredField,
  [expiryDateField]: documentDateValidator,
  [usernameField]: requiredField.pipe(
    z.string().min(6, 'error.minLength.6').max(50, 'error.maxLength.50'),
  ),
  [passwordField]: basePasswordFieldValidation,
  [flagPrivacyField]: z.boolean().refine((value) => value),
});

export type SecurityDataFormType = z.infer<
  typeof securityDataStepFormValidationBaseSchema
>;

export const errorPage = {
  blacklist: 'err.e2063',
};
